export default __webpack_public_path__ + "static/media/Punto_07_Il_Pontino_ITA_Def.8cc089d0.aac";